import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import template from './Users.vue';

@Component({
	mixins: [template]
})
export default class CustomerEditUsers extends Vue {
	users: boolean = false;
}
